import { types } from "mobx-state-tree";
import { PatientModel } from "./PatientModel";

export const ReferralModel = types.model("ReferralModel", {
  id: types.identifier,
  referralId: types.string,
  patient: types.maybeNull(types.reference(types.late(() => PatientModel))),
});
